import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const BarlineChartGlyph = /*#__PURE__*/createElement("g", {
  id: "barline_chart",
  transform: "scale(3.5)",
  fill: "none"
}, /*#__PURE__*/createElement("path", {
  d: "M0.5 23.1H23.5M3.8999 8.8L6.5999 6.2M9.69995 5.8L12.2 7.2M15.6001 7.00001L19.5001 4.10001M4.5 19.7C4.5 19.4 4.3 19.2 4 19.2H2C1.7 19.2 1.5 19.4 1.5 19.7V23.1H4.5V19.7ZM10.5 14.9C10.5 14.6 10.3 14.4 10 14.4H8C7.7 14.4 7.5 14.6 7.5 14.9V23.1H10.5V14.9ZM16.5 17.8C16.5 17.5 16.3 17.3 16 17.3H14C13.7 17.3 13.5 17.5 13.5 17.8V23.1H16.5V17.8ZM22.5 10.1C22.5 9.80001 22.3 9.60001 22 9.60001H20C19.7 9.60001 19.5 9.80001 19.5 10.1V23.1H22.5V10.1ZM21 4.8C22.1 4.8 23 3.9 23 2.9C23 1.8 22.1 1 21 1C19.9 1 19 1.9 19 2.9C19 4 19.9 4.8 21 4.8ZM14 10.1C15.1 10.1 16 9.2 16 8.2C16 7.1 15.1 6.3 14 6.3C12.9 6.3 12 7.2 12 8.2C12 9.3 12.9 10.1 14 10.1ZM8 6.8C9.1 6.8 10 5.9 10 4.9C10 3.8 9.1 3 8 3C6.9 3 6 3.9 6 4.9C6 5.9 6.9 6.8 8 6.8ZM2.5 12C3.6 12 4.5 11.1 4.5 10.1C4.5 9 3.6 8.2 2.5 8.2C1.4 8.2 0.5 9.1 0.5 10.1C0.5 11.2 1.4 12 2.5 12Z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
const BarlineChart = createSvg({
  name: 'barline_chart',
  path: BarlineChartGlyph
});

export default BarlineChart;
export { BarlineChartGlyph };
